import axiosInstance from "./AxiosInstance";

export default {
    get() {
        return axiosInstance({
            method: "get",
            url: "/registrations",
        });
    },
    create(body) {
        return axiosInstance({
            method: "post",
            url: "/registrations",
            data: body,
        });
    },
    update(id, body) {
        return axiosInstance({
            method: "patch",
            url: `/registrations/${id}`,
            data: body,
        });
    },
    delete(id) {
        return axiosInstance({
            method: "delete",
            url: `/registrations/${id}`,
        });
    },
    finish(id) {
        return axiosInstance({
            method: "patch",
            url: `/registrations/button/finish/${id}`,
        });
    },
    didNotShow(id) {
        return axiosInstance({
            method: "patch",
            url: `/registrations/button/no_show/${id}`,
        });
    },
};
